import React from 'react';
import ReactDOMServer from 'react-dom/server';

// Dependencies
import jsxToString from 'jsx-to-string';

// Components
import Snippet from '../../../common/Snippet';
import Stepper  from '../../../common/Stepper';

const steps = ['Step 1', 'Step 2', 'Step 3'];

const Primary = class Primary extends React.Component {
  example = (
    <Stepper
      clickable
      currentStep={2}
      onClick={i => console.log(i)}
      steps={steps}
    />
  );

  render() {
    const { translation } = this.props;

    return (
      <section className="page__section">
        <h3>{translation.examples.primary}</h3>

        <article
          className="example"
        >
          {this.example}
        </article>

        <Snippet
          {...this.props}
          code={ReactDOMServer.renderToStaticMarkup(this.example)}
          name="primary"
          react={jsxToString(this.example)}
        />
      </section>
    )
  }
}

export default Primary;
